import type { ReactNode } from "react";
import Breadcrumb from "../../shared/Breadcrumb";
import Lazy from "../../shared/Lazy";
import PaperContainer from "../../shared/PaperContainer";
import Export from "./Export";

export const PATH = "/admin/tools";
export const TITLE = "Admin\u00a0Tools";

function Tool({ title, children }: { title: string; children: ReactNode }) {
  return (
    <PaperContainer sx={{ h2: { marginTop: 0 } }}>
      <h2>{title}</h2>
      <Lazy label="Show">{children}</Lazy>
    </PaperContainer>
  );
}

export default function AdminToolsPage() {
  const path = [{ path: PATH, label: TITLE }];
  return (
    <article>
      <Breadcrumb path={path} />
      <h1>{TITLE}</h1>

      <Tool title="Export Report Data">
        <Export />
      </Tool>
    </article>
  );
}
